<template>
  <div
    class="status-controls"
  >
    <reaction-menu
      :id="currentStatus.id"
      content-type="status"
    />
    <router-link
      :to="historyRoute"
      class="status-controls__button"
      tag="button"
    >
      <icon-component name="text-bubble" class="status-controls__action-icon" />
      <span
        v-if="replyCount !== 0"
        class="status-controls__action-count"
      >{{ replyCount }}</span>
      <span class="status-controls__action-text">{{ textContent }}</span>
    </router-link>
    <button
      v-if="onUserProfile"
      class="status-controls__button status-controls__button--new-status"
      @click="$emit('openStatusForm')"
    >
      <icon-component name="pencil" class="status-controls__action-icon" />
      <span class="status-controls__action-text">new</span>
    </button>
    <context-menu>
      <template v-slot:allUsers>
        <context-menu-option
          v-if="onUserProfile"
          class="context-menu-option--new-status"
          icon="pencil"
          @click="$emit('openStatusForm')"
        >new</context-menu-option>
        <context-menu-option
          v-if="onUserProfile"
          icon="trash-can"
          delete-type="status"
          @click="deleteStatus"
        >Delete</context-menu-option>
        <context-menu-option :link-route="historyRoute" icon="clock">View status history</context-menu-option>
      </template>
    </context-menu>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ReactionMenu from '@/components/Reactions/ReactionMenu.vue';
import ContextMenu from '@/components/Engagement/ContextMenu.vue';
import ContextMenuOption from '@/components/Engagement/ContextMenuOption.vue';
import { DELETE_USER_STATUS } from '@/graphql/mutations/status-mutation';

export default {
  name: 'StatusControls',
  components: {
    ReactionMenu,
    ContextMenu,
    ContextMenuOption,
  },
  props: {
    currentStatus: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters(['currentUser']),
    onUserProfile() {
      return this.$route.name === 'userProfileOverview';
    },
    onCommunityHub() {
      return this.$route.name === 'community';
    },
    replyCount() {
      return this.currentStatus.replies.length;
    },
    textContent() {
      if (this.replyCount === 1) {
        return 'reply';
      }
      return 'replies';
    },
    historyRoute() {
      if (this.onUserProfile || this.onCommunityHub) {
        return {
          name: 'memberProfileStatus',
          params: {
            slug: this.currentUser.slug,
          },
        };
      }
      return {
        name: 'memberProfileStatus',
        params: {
          slug: this.$route.params.slug,
        },
      };
    },
  },
  methods: {
    deleteStatus() {
      this.$apollo.mutate({
        mutation: DELETE_USER_STATUS,
        variables: {
          id: this.currentStatus.id,
        },
      }).then(() => {
        this.$store.dispatch('addToastNotification', {
          toastType: 'success',
          description: 'Your status update has been deleted.',
          type: 'Status Update',
        });
        this.$emit('showPlaceholder');
      }).catch(() => {
        this.$store.dispatch('addGenericErrorNotification');
      });
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '@/stylesheets/components/_status-controls';
</style>
